export default __webpack_public_path__ + "static/audio-1844798_1920-05217c012e69ec861370a310f872aa79.jpg";